<template>
  <multiselect
    :model-value="modelValue"
    :options="options"
    :custom-label="
      typeof label === 'function'
        ? label
        : (object: Record<string, unknown>) => object[label as string] ?? object
    "
    :deselect-label="$t('multiselect.deselect')"
    :disabled="disabled"
    :placeholder="placeholder ?? $t('generic.selectOption')"
    :track-by="trackBy"
    :loading="loading"
    :options-limit="optionsLimit"
    :select-label="$t('spGroupModal.pressEnterToSelect')"
    :selected-label="$tt('multiselect.selected')"
    :show-no-results="true"
    :show-no-options="false"
    :class="{
      error: isError,
    }"
    @update:model-value="updateValue"
    @search-change="emitSearchChange"
    @select="emitSelect"
  >
    <template #noResult>{{ $t('spGroupModal.noResults') }}</template>
    <template #singleLabel>
      <slot name="singleLabel"></slot>
    </template>
    <template #option="props">
      <slot name="option" :option="props"></slot>
    </template>
  </multiselect>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import Multiselect from 'vue-multiselect';
  import 'vue-multiselect/dist/vue-multiselect.min.css';

  export default defineComponent({
    name: 'StyledMultiselect',
    components: { Multiselect },

    props: {
      modelValue: {
        type: [Array, String, Object, Number, Boolean, null],
        default: () => [],
      },
      options: {
        type: Array,
        required: true,
      },
      label: {
        type: [String, Function],
        required: false,
      },
      placeholder: {
        type: String,
        required: false,
      },
      trackBy: {
        type: String,
        required: false,
      },
      loading: {
        type: Boolean,
        required: false,
      },
      isError: {
        type: Boolean,
        required: false,
        default: false,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      optionsLimit: {
        type: Number,
        required: false,
        default: 1000,
      },
    },

    emits: ['update:modelValue', 'search-change', 'select'],

    methods: {
      updateValue(newValue: any) {
        this.$emit('update:modelValue', newValue);
      },

      emitSearchChange(search: string) {
        this.$emit('search-change', search);
      },

      emitSelect(selection: string) {
        this.$emit('select', selection);
      },
    },
  });
</script>

<style lang="scss" scoped>
  :deep(.multiselect__option--highlight) {
    background-color: $selected-color;
    color: black;
    font-weight: 500;
  }

  :deep(.multiselect__placeholder) {
    color: $placeholder-font-color;
  }

  :deep(.multiselect__option) {
    &:after {
      background-color: $selected-color;
    }
  }
</style>
